import FormattedJSXMessage from 'I18n/components/FormattedJSXMessage';
import FormattedDateTime from 'I18n/components/FormattedDateTime';
import { Alert } from 'foundations-components/transitional/components/Alert';
import { gate } from 'hub-http/gates';
import { BLOG_RESEARCH_AGENT_SUNSET_DATE_MS } from 'marketplace-ui-common/constants/Agents';
import { useDetailsPageContext } from 'marketplace-ui-common/context/DetailsPageContext';
import { getIsBlogResearchAgentListing } from 'marketplace-ui-common/utils/agents';
import { jsx as _jsx } from "react/jsx-runtime";
export function BlogResearchAgentSunsetBanner({
  listingSlug
}) {
  var _userInfo$gates;
  const {
    userInfo
  } = useDetailsPageContext();
  const isUngatedForSunsetBanner = userInfo === null || userInfo === void 0 || (_userInfo$gates = userInfo.gates) === null || _userInfo$gates === void 0 ? void 0 : _userInfo$gates.includes(gate('LFC:BlogResearch:SunsetBanner'));
  if (!getIsBlogResearchAgentListing(listingSlug) || !isUngatedForSunsetBanner) {
    return null;
  }
  return /*#__PURE__*/_jsx(Alert, {
    marginBlockEnd: "600",
    type: "info",
    closeable: false,
    children: /*#__PURE__*/_jsx(FormattedJSXMessage, {
      message: "detailsPage.blogResearchAgentSunsetBanner.message_jsx",
      elements: {
        Date: FormattedDateTime
      },
      options: {
        format: 'LL',
        type: 'utc',
        value: BLOG_RESEARCH_AGENT_SUNSET_DATE_MS
      }
    })
  });
}